import * as React from 'react'
import { memo } from 'react'
const SvgChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.36 6">
    <path d="M1.08 3.48A3.9 3.9 0 0 0 0 6a16.5 16.5 0 0 1 6.36-3A15.7 15.7 0 0 1 0 0a4.1 4.1 0 0 0 1.2 2.52Z" />
  </svg>
)
const Memo = memo(SvgChevronRight)
export default Memo
